/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Widget from 'components/Widget/index';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import PropTypes from 'prop-types';
import { chartColors } from 'util/chartUtils';
import WidgetRainbow from '../../common/WidgetRainbow';
import IntlMessages from "../../../../../util/IntlMessages";
import { useLocalizedMessage } from '../../../../../util/useLocalizedMessage';

const AffectedUsers = ({ lostOpportunities }) => {
  const t = useLocalizedMessage();
  const { isFetched, isFetching, users, error } = lostOpportunities;

  if (isFetching || !isFetched) {
    return (
      <Widget styleName="jr-card-full noMargin">
        <PlaceholderSpinner height={129} />
      </Widget>
    );
  }

  const mainNumber = error || !(users && users.filteredTotal)
    ? '-'
    : users.filteredTotal;
  const pieData = [
    { id: '1', name: t('analytics.affectedUsers.title'), fill: chartColors.main.normal, value: users ? users.filteredTotal : '-' },
    { id: '2', name: t('analytics.otherUsers.title'), fill: chartColors.main.light, value: users ? users.otherTotal : '-' },
  ];

  return (
    <WidgetRainbow
      description={<IntlMessages id="analytics.affectedUsersLowCtr.description" />}
      mainNumber={mainNumber}
      pieData={pieData}
      title={<IntlMessages id="analytics.affectedUsersLowCtr.title" />}
      tone="lostOpportunities"
    />
  );
};

AffectedUsers.propTypes = {
  lostOpportunities: PropTypes.shape({
    isFetched: PropTypes.bool.isRequired,
    isFetching: PropTypes.bool.isRequired,
    users: PropTypes.shape({
      total: PropTypes.any.isRequired,
      filteredTotal: PropTypes.any.isRequired,
    }),
  }).isRequired,
};

export default AffectedUsers;
